import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cat',
  templateUrl: './cat.component.html',
  styleUrls: ['./cat.component.scss']
})
export class CatComponent implements OnInit {

  public isActive: boolean = false;
  public isIn: boolean = false;
  public isOut: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  toggleCat(): void {
    if (this.isIn || this.isOut)
      return;
    if (!this.isActive) {
      this.isIn = true;
      this.isActive = true;
      this.isOut = false;
      window.setTimeout(() => {
        this.isIn = false;
      }, 750);
    } else {
      this.isOut = true;
      this.isIn = false;
      window.setTimeout(() => {
        this.isOut = false;
        this.isActive = false;
      }, 500);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/cat/cat.component.ts